import { render } from "./monthmarket.vue?vue&type=template&id=ef547b70"
import script from "./monthmarket.vue?vue&type=script&lang=js"
export * from "./monthmarket.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__